import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-grupo-botones',
  templateUrl: './grupo-botones.component.html',
  styleUrls: ['./grupo-botones.component.scss']
})
export class GrupoBotonesComponent implements OnInit {

  constructor() { }

  @Input() botones: string[]
  @Input() seleccionado: string
  @Output() funcionEvent = new EventEmitter<string>();

  ngOnInit() {
  }

  handleClick(boton: string): void {
    this.funcionEvent.emit(boton);
  }

}
